/**
 * 【KYMW2300】工程履歴チェック要求VO
 *
 * @export CheckProgressHistoryModel
 * @class CheckProgressHistoryModel
 */
export class CheckProgressHistoryModel {
  /** 受注コード */
  public orderCode = String('');
  /** 媒体区分 */
  public mediumType = String('');
  /** 工程管理番号(出力対象、比較フェーズ) */
  public progressNum = String('');
  /** チェック区分　１：出力対象、２：比較フェーズ */
  public checkType = String('');
}
